<template>
<div class="shopping-cart--shipping">
    <div class="row checkoutTitle">
        <div class="col-12">{{$t('checkout.shipping_and_payment')}}</div>
    </div>
    <div class="row">
        <div class="col-12 col-md-6">
            <table>
                <colgroup>
                    <col width="1px" />
                    <col />
                </colgroup>
                <tr>
                    <td>{{$t('auth.register.form.name')}}:</td>
                    <td>{{ user.first_name }}</td>
                </tr>
                <tr>
                    <td>{{$t('auth.register.form.lastname')}}:</td>
                    <td>{{ user.last_name }}</td>
                </tr>
                <tr>
                    <td>{{$t('auth.register.form.address')}}:</td>
                    <td>{{ user.address }}</td>
                </tr>
                <tr>
                    <td>{{$t('auth.register.form.zip')}}:</td>
                    <td>{{ user.zip }}</td>
                </tr>
                <tr>
                    <td>{{$t('auth.register.form.city')}}:</td>
                    <td>{{ user.city }}</td>
                </tr>
                <tr>
                    <td>{{$t('auth.register.form.country')}}:</td>
                    <td>{{ user.country }}</td>
                </tr>
            </table>
            <button type="button" @click.prevent="useAltDelivery = !useAltDelivery" class="btn btn-outline-link w-100">{{$t('cart.shipping.different_address')}}<div class="icon icon-arrow-down"></div></button>
            <transition name="fade">
                <div class="collapse show" id="deliveryAddress" v-if="useAltDelivery">
                    <input-field :label="$t('auth.register.form.name')" v-model="delivery.firstname" type="text" name="firstname" :required="true" :autofocus="true"></input-field>
                    <input-field :label="$t('auth.register.form.lastname')" v-model="delivery.lastname" type="text" name="lastname" :required="true"></input-field>
                    <input-field :label="$t('auth.register.form.address')" v-model="delivery.address" type="text" name="address" :required="true"></input-field>
                    <input-field :label="$t('auth.register.form.zip')" v-model="delivery.zip" type="text" name="zip" :required="true"></input-field>
                    <input-field :label="$t('auth.register.form.city')" v-model="delivery.city" type="text" name="city" :required="true"></input-field>
                    <div class="form-group">
                      <label for="country" class="control-label">{{$t('auth.register.form.country')}} <span class="required">*</span></label>
                      <select id="country" name="country" class="form-control" v-model="delivery.country">
                        <option v-for="coutry in $t('countries')" :key="coutry" :value="coutry">{{coutry}}</option>
                      </select>
                    </div>
                </div>
            </transition>
        </div>
        <div class="col-12 col-md-6" v-if="shippingData">
            <div class="form-group" v-for="(option, index) in shippingData.options" :key="index">
                <div class="radio2">
                    <label>
                        <input name="deliveryType" :value="index" type="radio" v-model="selectedOption" />
                        <span>
                            <div>
                                <div class="name">
                                    {{ option.name }}
                                    <div class="rightContent" v-if="brutto_discounted < shippingData.freeShipping && !(coupon && coupon.free_delivery == 1)">{{ option.amount | money }}</div>
                                </div>
                                <div class="text" v-if="option.name == 'Osebni prevzem'">
                                  Paket bom prevzel/a v poslovalnici: <select name="locationId" v-if="option.name == 'Osebni prevzem'" v-model="selectedLocation">
                                    <option v-for="(loca, index) in shippingData.options[1].locations" :key="index" :value="index" v-if="shippingData.inWarehouses[index]">{{ loca }}</option>
                                  </select>
                                </div>
                                <div class="text" v-else>{{ option.description }}</div>
                            </div>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import InputField from '@Components/checkout/modules/InputField'
import { createNamespacedHelpers as nsHelper } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

const {
  mapState: mapUserState
} = nsHelper('user')

const {
  mapState: mapShippingState,
  mapActions: mapShippingActions
} = nsHelper('cart/shipping')

const {
  mapState: mapCartState,
  mapGetters: mapCartGetters
} = nsHelper('cart')

export default {

  components: {
    InputField
  },

  data () {
    return {
      delivery: cloneDeep(this.$store.state.cart.shipping.altShipping)
    }
  },

  computed: {
    ...mapCartGetters(['brutto_discounted']),
    ...mapCartState(['coupon']),
    ...mapUserState(['user']),
    ...mapShippingState({
      shippingData: 'data',
      useAlt: 'useAlt',
      option: 'option',
      locationId: 'locationId'
    }),

    useAltDelivery: {
      get () {
        return this.useAlt
      },
      set (value) {
        this.setUseAltShipping(value)
      }
    },

    selectedOption: {
      get () {
        return this.option
      },
      set (value) {
        this.setShippingOption(value)
      }
    },

    selectedLocation: {
      get () {
        return this.locationId == 0 ? 69 : this.locationId
      },
      set (value) {
        this.setShippingLocationId(value)
      }
    }
  },

  methods: mapShippingActions([
    'setAltShipping',
    'setShippingOption',
    'setShippingLocationId',
    'setUseAltShipping'
  ]),

  filters: {
    money (value) {
      return parseFloat(value).toLocaleString('sl-SI', {style: 'currency', currency: 'EUR'})
    }
  },

  watch: {
    delivery: {
      deep: true,
      handler: function (altShipping) {
        this.setAltShipping({ altShipping })
      }
    }
  }

}
</script>
